import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Mascot from '../../components/Mascot';

export default function ParentLogin() {
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      const res = await fetch('/api/parent/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        setErr('Wrong password');
        setLoading(false);
        return;
      }
      navigate('/parent', { replace: true });
    } catch {
      setErr('Network error');
      setLoading(false);
    }
  };

  return (
    <div className="max-w-sm mx-auto px-5 pt-16 safe-top space-y-6 text-center">
      <Mascot mood="thinking" size={96} className="mx-auto" />
      <h1 className="font-display font-black text-2xl">Parent sign in</h1>
      <form onSubmit={submit} className="space-y-4 text-left">
        <label className="block">
          <span className="text-sm text-ink/70">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            className="mt-1 w-full card p-3 outline-none focus:ring-2 focus:ring-coral/50"
          />
        </label>
        {err && <p className="text-coral text-sm">{err}</p>}
        <button type="submit" className="btn-primary w-full" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
